<script setup lang="ts">
import SingleMetricResponseDTO = App.Data.Explorer.DataTable.SingleMetricResponseDTO;
import { computed } from "vue";
import SingleMetricSuccess from "@/modules/explorer/components/SingleMetric/SingleMetricSuccess.vue";
import SingleMetricError from "@/modules/explorer/components/SingleMetric/SingleMetricError.vue";
import DocumentDO = App.Data.Explorer.DocumentDO;
import { buildSingleMetricTitle } from "@/modules/explorer/components/SingleMetric/util";

const { document, isLoading, singleMetric, errorMessage, emitTitle } =
	defineProps<{
		document: DocumentDO;
		isLoading: boolean;
		singleMetric: SingleMetricResponseDTO | null;
		errorMessage: string | null;
		emitTitle: (title: string) => void;
		hideTitle: boolean;
	}>();

const isError = computed(() => singleMetric === null);

const title = computed(() => {
	if (!document.single_metric) {
		return "No metric selected, right click in a table (header) to configure one.";
	}

	const builtTitle = buildSingleMetricTitle(document);
	emitTitle(builtTitle);

	return builtTitle;
});
</script>

<template>
	<div class="d-flex flex-column justify-center align-center">
		<v-skeleton-loader v-if="isLoading" type="heading,heading" width="200" />

		<template v-else>
			<template v-if="isError">
				<single-metric-error
					v-if="isError"
					:title="title"
					:error-message="errorMessage"
				/>
			</template>

			<template v-else>
				<h3 class="font-weight-regular" v-if="!hideTitle">{{ title }}</h3>
				<single-metric-success
					v-if="singleMetric"
					:single-metric="singleMetric"
				/>
			</template>
		</template>
	</div>
</template>
